<div class="settings-user-management">
    <div class="glass-card border border-white border-opacity-10 p-3 rounded-4 mb-3">
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
            <div>
                <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <h4 class="text-white fw-bold mb-0">User Management</h4>
                    <span class="badge rounded-pill settings-soft-badge">{{ users.length }} users</span>
                    <span class="badge rounded-pill settings-soft-badge settings-soft-badge-success">{{ active_users_count }} active</span>
                </div>
                <p class="text-white-50 mb-0 text-sm">
                    Add users, update their roles, and manage account access.
                </p>
            </div>

            <button
                type="button"
                class="btn-primary rounded-3 d-flex align-items-center gap-1 settings-add-user-trigger"
                @click="open_add_user"
            >
                <i class="bi bi-person-plus-fill fs-6"></i>
                <span class="text-xs">Add user</span>
            </button>
        </div>
    </div>

    <SnackbarMessage
        :error-message="load_error"
        :success-message="save_success"
        @dismiss-error="load_error = ''"
        @dismiss-success="save_success = ''"
    />

    <div class="table-responsive settings-table-shell settings-reference-table rounded-4 border border-white border-opacity-10">
        <div v-if="is_loading" class="d-flex align-items-center gap-3 text-white-50 p-3">
            <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
            <span class="text-xs">Loading users...</span>
        </div>

        <div v-else-if="!users.length" class="text-center text-white py-4 text-xs">
            <div class="d-flex flex-column align-items-center justify-content-center py-4">
                <span class="d-inline-flex align-items-center justify-content-center rounded-circle border border-white border-opacity-10 bg-white bg-opacity-10 text-white mb-3" style="width: 2.5rem; height: 2.5rem;">
                    <i class="bi bi-people-fill"></i>
                </span>
                <p class="text-white fw-semibold mb-1">No users available</p>
                <p class="text-white text-xs mb-0">Added users will appear here.</p>
            </div>
        </div>

        <table
            v-else
            class="table table-dark table-hover align-middle mb-0 settings-data-table global_data_table text-xs"
            data-search-placeholder="Search users"
            data-non-orderable-targets="[4]"
            data-page-length="5"
            data-order-column="0"
            data-order-direction="asc"
        >
            <thead>
                <tr>
                    <th scope="col" class="settings-table-head text-white fw-semibold text-xs">User</th>
                    <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Email</th>
                    <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Role</th>
                    <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Status</th>
                    <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Last Login</th>
                    <th scope="col" class="settings-table-head text-white fw-semibold text-xs text-end">Actions</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="user in users" :key="user.id">
                    <td>
                        <div class="d-flex align-items-center gap-2">
                            <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle">
                                {{ get_initials(user) }}
                            </span>
                            <div class="d-flex flex-column gap-1">
                                <span class="text-white fw-semibold text-xs">{{ get_full_name(user) }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="text-white fw-semibold text-xs">{{ user.email || "-" }}</td>
                    <td>
                        <span class="badge rounded-pill settings-soft-badge settings-soft-badge-info text-xs">
                            {{ user.role || "-" }}
                        </span>
                    </td>
                    <td>
                        <span
                            class="badge rounded-pill text-xs"
                            :class="user.is_active ? 'settings-status-active' : 'settings-status-inactive'"
                        >
                            {{ user.is_active ? "Active" : "Inactive" }}
                        </span>
                    </td>
                    <td class="text-white-50 text-xs">{{ get_last_login_label(user) }}</td>
                    <td>
                        <div class="d-flex justify-content-end gap-2 flex-wrap">
                            <button
                                type="button"
                                class="btn button-outline btn-outline-light rounded-3 d-flex align-items-center gap-1 settings-button-shape settings-action-button"
                                @click="open_edit_user(user)"
                                aria-label="Edit user"
                            >
                                <i class="bi bi-pencil-square"></i>
                                <span class="text-xs">Edit</span>
                            </button>

                            <button
                                type="button"
                                class="btn-primary rounded-3 d-flex align-items-center gap-1 settings-button-shape settings-action-button"
                                @click="toggle_user_status(user)"
                                :disabled="is_saving || (is_current_user(user) && user.is_active)"
                                :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                                :title="is_current_user(user) && user.is_active ? 'You cannot deactivate your own account' : ''"
                            >
                                <span class="text-xs">{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <SettingsAddUserModal
        :is_open="show_add_user_modal"
        :is_saving="is_saving"
        :form_error="form_error"
        :role_options="role_options"
        :is_loading_roles="is_loading_roles"
        @close="close_add_user_modal"
        @submit="add_user"
    />

</div>
